import {render} from "react-dom"
import React from "react"
import LeasePrice from "../../src/components/LeasePrice"

window.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('result_list_container') != null){
    const itemList = extractItemList()

    itemList.forEach((item) => {
      render(
        <LeasePrice itemId={item.id} leasePrice={item.leasePrice}/>,
        document.querySelector(`[item_id="${item.id}"]`)
      )
    })
  }
})

function extractItemList() {
  const leasePriceDomList = Array.from(document.getElementsByClassName('leasePrice'))
  return leasePriceDomList.map((lease_price_dom) => {
    return {
      'id': lease_price_dom.getAttribute('item_id'),
      'leasePrice': lease_price_dom.getAttribute('lease_price')
    }
  })
}
